angular.module('satv.playlist.pitch')
.directive('injectScript', function() {
    return {
        restrict: 'EA',
        link: function(s, el, a){
            var script = document.createElement('script');
            script.src = a.url;
            el.append(script);
        }
    };
});



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/directives/InjectScript.js